import React from "react";
import Image from "next/image";
const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

interface Card {
  title: string;
  display_title: string;
  description: string;
  description_two: string;
  image: {
    data: {
      attributes: {
        url: string;
      };
    };
  };
}
interface Block {
  title: string;
  cards: Card[];
  sub_title: string;
  description: string;
  description_two: string;
  image: {
    data: {
      attributes: {
        url: string;
      };
    };
  };
}
interface Props {
  block: Block;
}
const Strategy: React.FC<Props> = ({ block }) => (
  <>
    <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white before:content-[''] before:absolute before:h-[100%] before:inset-0 before:bg-[url('/images/client-bg.png')] before:bg-no-repeat before:bg-[length:100%_100%] before:bg-center before:bg-[#F0F8FF] before:-z-10">
      <div className="container">
        <div className={` mb-[32px] lg:mb-[32px] xl:mb-[40px] `}>
          <p className="text-heading-6 font-regular text-primary-text mb-[12px] text-center">
            {block?.title ?? ""}
          </p>
          <h2 className="font-bold text-heading-1 text-primary-text mb-[12px] text-center">
            {block?.sub_title ?? ""}
          </h2>
          <p className="text-heading-6 font-regular text-primary-text mb-[0px] text-center">
            {block?.description ?? ""}
          </p>
        </div>
        <div className="flex items-center justify-center">
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-[30px] md:gap-[24px] gap-[16px]">
            {block?.cards?.map((card, index) => (
              <div
                key={"card" + index}
                className="bg-white p-[30px_20px] md:p-[48px_48px] relative z-[1] h-[350px] md:h-[422px] group overflow-hidden"
              >
                <div className="flex justify-center mb-[32px]">
                  <Image
                    src={
                      card?.image?.data?.attributes?.url
                        ? baseUrl + card.image.data.attributes.url
                        : `/images/leadership/card-icon-${index + 1}.svg`
                    }
                    alt={"Strategy Image" + (index + 1)}
                    width={72}
                    height={72}
                    className="object-cover w-[72px] h-[72px] opacity-[0.5] group-hover:opacity-100 transition-all duration-500 ease-in-out"
                  />
                </div>
                <h3 className="text-heading-4 font-bold text-primary-text mb-[32px] text-center">
                  {card?.display_title ?? ""}
                </h3>
                <p className="text-subtitle-3 font-regular text-[#32343B] mb-[0px] text-center">
                  {card?.title ?? ""}
                </p>
                <div className="absolute bottom-[-20px] group-hover:bottom-[0px] transition-all duration-500 ease-in-out left-0 w-full">
                  <Image
                    src="/images/leadership/card-bg.png"
                    alt={"Strategy Image" + (index + 10)}
                    width={296}
                    height={100}
                    className="object-cover w-full h-full"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Strategy;
